import Swiper, {Navigation, Pagination} from 'swiper';

export const projectsGallery = (targetSelector) => {
    const options = {
        speed: 3000
    };

    console.log(targetSelector);
    const Carousel = new Swiper(targetSelector, {
        modules: [Navigation, Pagination],
        loop: true,
        // loopedSlides: 2,
        autoplay: false,
        allowTouchMove: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    console.log(Carousel);
};